export type EnnismoreServicePrefix =
  | 'config'
  | 'booking'
  | 'payment'
  | 'gateway/ows';

export type GatewayType = 'kong' | 'aws-api-gateway';
export type Dialect = 'ohip' | 'ows';

/**
 * The Ennismore API has a bunch of different variations of base URL for services.
 * https://api.dev.env.ennismore.com (OWS via Kong)
 * https://api.dev.env.ennismore.com/v2 (OWS via Kong with v2 prefix)
 * https://api.dev.env.ennismore.com/booking_api.v1.BookingApiService (OHIP via Kong)
 * https://gateway.dev.env.ennismore.com/booking/booking_api.v1.BookingApiService (OHIP via AWS API Gateway)
 * https://gateway.dev.env.ennismore.com/gateway/ows (OWS via AWS API Gateway)
 *
 * @param baseUrl
 * @param config
 */
export function buildBaseUrl(
  baseUrl: string,
  config: {
    servicePrefix: EnnismoreServicePrefix;
    gatewayType?: GatewayType;
    dialect?: Dialect;
  }
) {
  function gatewayTypeWithDefault() {
    if (config.gatewayType) return config.gatewayType;

    return baseUrl.startsWith('https://gateway') ? 'aws-api-gateway' : 'kong';
  }

  const gateway = gatewayTypeWithDefault();

  if (gateway === 'aws-api-gateway') {
    // AWS API Gateway requires service prefix in the path
    const url = new URL(config.servicePrefix, baseUrl);
    return url.toString();
  }

  // Kong gateway - handle special cases
  if (
    gateway === 'kong' &&
    config.dialect === 'ows' &&
    config.servicePrefix === 'gateway/ows'
  ) {
    // OWS via Kong uses /v2 prefix
    const url = new URL(baseUrl);

    if (!url.pathname.includes('/v2')) {
      url.pathname = '/v2';
    }

    return url.toString();
  }

  // Default behavior for Kong
  return baseUrl;
}
